import { getSdkApollo } from "../client/sdk";
import { graphqlClient } from "./client";

/**
 * @deprecated The method should not be used
 */
export const legacyGraphqlSdk = getSdkApollo(graphqlClient);
